import { Instance } from 'mobx-state-tree';
import { RouteOptimizedDtoModelBase } from './RouteOptimizedDtoModel.base';

/* The TypeScript type of an instance of RouteOptimizedDtoModel */
export interface RouteOptimizedDtoModelType extends Instance<typeof RouteOptimizedDtoModel.Type> {}

/* A graphql query fragment builders for RouteOptimizedDtoModel */
export { selectFromRouteOptimizedDto, routeOptimizedDtoModelPrimitives, RouteOptimizedDtoModelSelector } from './RouteOptimizedDtoModel.base';

/**
 * RouteOptimizedDtoModel
 */
export const RouteOptimizedDtoModel = RouteOptimizedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
